import { Col, Image, Layout, Row, Typography } from 'antd';
import React from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from 'react-icons/fa';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { Link, Outlet } from 'react-router-dom';
import logo from '../../assets/img/logo/jurisvip-all-branco-transparente-menor.png';
import NavbarComponent from '../../components/Navbar';

class WebMain extends React.Component {
  onClick = () => {
    window.document.getElementById('web-content').scrollTo(0, 0);
  };

  render = () => {
    return (
      <Layout.Content className="web-body">
        <NavbarComponent />
        <Layout.Content className="web-content" id="web-content">
          <div id="teste-div">
            <Outlet />
          </div>
          <Row style={{ marginTop: 40 }}>
            <Col className="home-col-black" span={24}>
              <Row className="home-row-page-footer" gutter={[16, 30]}>
                <Col className="home-row-col" md={8} xs={24}>
                  <Image
                    preview={false}
                    src={logo}
                    style={{ marginBottom: 10 }}
                    width={'50%'}
                  />
                  <Typography className="home-row-page-footer-text">
                    <span>E-mail:</span> info@example.com
                  </Typography>
                  <Row gutter={[8, 8]} style={{ marginTop: 10 }}>
                    <Col>
                      <a className="home-row-page-footer-social" href={'#1'}>
                        <FaInstagram color="#FFF" />
                      </a>
                    </Col>
                    <Col>
                      <a className="home-row-page-footer-social" href={'#1'}>
                        <FaFacebookF color="#FFF" />
                      </a>
                    </Col>
                    <Col>
                      <a className="home-row-page-footer-social" href={'#1'}>
                        <FaLinkedin color="#FFF" />
                      </a>
                    </Col>
                    <Col>
                      <a className="home-row-page-footer-social" href={'#1'}>
                        <FaTwitter color="#FFF" />
                      </a>
                    </Col>
                  </Row>
                </Col>
                <Col md={8} xs={12}>
                  <Typography className="home-row-page-footer-title">
                    Link Úteis
                  </Typography>
                  <Link onClick={this.onClick} to="/">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Home
                    </Typography>
                  </Link>
                  <Link onClick={this.onClick} to="/quemsomos">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Quem Somos
                    </Typography>
                  </Link>
                  <Link onClick={this.onClick} to="/termos">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Termos de Uso
                    </Typography>
                  </Link>
                  <Link onClick={this.onClick} to="/politica">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Política de Privacidade
                    </Typography>
                  </Link>
                </Col>
                <Col md={8} xs={12}>
                  <Typography className="home-row-page-footer-title">
                    JurisVip
                  </Typography>
                  <Link onClick={this.onClick} to="/planos">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Planos
                    </Typography>
                  </Link>
                  <Link onClick={this.onClick} to="/advogados">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Advogados
                    </Typography>
                  </Link>
                  <Link onClick={this.onClick} to="/faq">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> FAQ - Perguntas Frequentes
                    </Typography>
                  </Link>
                  <Link onClick={this.onClick} to="/contato">
                    <Typography className="home-row-page-footer-link">
                      {' '}
                      <IoChevronForwardOutline /> Contato
                    </Typography>
                  </Link>
                </Col>
              </Row>
            </Col>
            <Col className="home-col-copy" span={24}>
              <Typography className="home-copy">
                © Copyright <b>JurisVip</b>. Todos os direitos reservados.
              </Typography>
            </Col>
          </Row>
        </Layout.Content>
      </Layout.Content>
    );
  };
}

export default WebMain;
